import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getMlps, deleteMlp, updateMlpsPagination } from '../../store/actions/mlp/mlp_action';
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../ui_components/table_pagination';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import { roundNumber } from '../../utils/helper_functions';
import ActionsComponent from '../ui_components/actions_component';
import { formatDate } from '../../utils/helper_functions';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500
    }
}));

const MlpsTable = ({ mlps: { collection, totalCount, page, rowsPerPage, filters, totalValues } }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getMlps({ page, rowsPerPage, filters }));
        }
    }, []);

    useEffect(() => {
        dispatch(getMlps({ page, rowsPerPage, filters}))
    }, [page, rowsPerPage]);

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.MLP}/${uuid}`);
    }

    const handleDeleteMlp = (uuid) => {
        dispatch(deleteMlp(uuid))
            .then(() => dispatch(getMlps({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table" className={table}>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Klijent</TableCell>
                        <TableCell align="center">Datum</TableCell>
                        <TableCell align="center">Iznos</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, displayName, amount, date }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell align="center">{ displayName }</TableCell>
                            <TableCell align="center">{ formatDate(date) }</TableCell>
                            <TableCell align="center">{ roundNumber(amount) }</TableCell>
                            <TableCell align="right">
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeleteMlp(uuid)}
                                    deletable={true}
                                    label="MLP"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                    <TableRow hover className={tableRow}>
                         <TableCell align="center">{'Ukupno:'}</TableCell>
                         <TableCell colSpan="3" align="center">{ roundNumber(totalValues) }</TableCell>
                    </TableRow>
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updateMlpsPagination}
                 />
            </Table>
        </Paper>
    )
}

MlpsTable.propTypes = {
    mlps: PropTypes.object
}

const mapStateToProps = (state) => ({
    mlps: state.mlps
});

export default connect(mapStateToProps)(MlpsTable);
